import React, { useEffect, useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { FiLock, FiUser, FiArrowRight, FiAlertCircle } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { useAuth } from '../context/AuthContext';
import './AdminPages.css';

const AdminLoginPage = () => {
  const { login, isAuthed, ready } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (ready && isAuthed) nav('/admin/dashboard', { replace: true });
  }, [ready, isAuthed, nav]);

  if (!ready) return null;
  if (isAuthed) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const res = await login(form.username.trim(), form.password);
    setBusy(false);
    if (!res.ok) setError(res.error || 'Login failed');
    else nav('/admin/dashboard', { replace: true });
  };

  return (
    <>
      <SeoHead title="Admin login" description="THINKINGWORLD admin sign-in." path="/admin" />
      <div className="admin-shell admin-shell--auth">
        <div className="admin-auth-card">
          <div className="admin-auth-head">
            <span className="logo-mark logo-mark--image"><img src="/img/company-logo.png" alt="THINKINGWORLD" /></span>
            <h1>THINKINGWORLD Admin</h1>
            <p>Sign in to manage blogs, videos and webinars.</p>
          </div>

          <form onSubmit={submit} className="admin-auth-form">
            <label>
              <span><FiUser /> Username</span>
              <input
                type="text"
                required
                autoFocus
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                placeholder="admin"
              />
            </label>

            <label>
              <span><FiLock /> Password</span>
              <input
                type="password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••"
              />
            </label>

            {error && <p className="admin-auth-error"><FiAlertCircle /> {error}</p>}

            <button type="submit" className="btn btn-accent" disabled={busy}>
              {busy ? 'Signing in…' : (<>Sign in <FiArrowRight /></>)}
            </button>

            <p className="admin-auth-hint">
              Credentials are verified on the server. Set <code>ADMIN_USERNAME</code>, <code>ADMIN_PASSWORD</code> and <code>ADMIN_TOKEN</code> in Netlify. Locally, run <code>npm run dev</code> and open <code>localhost:3000</code> — login does not work under plain <code>npm start</code>.
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default AdminLoginPage;
